// extracted by mini-css-extract-plugin
export default {"nsp_offer_item_card_description":"NSPOfferItemCard_nsp_offer_item_card_description__1dRnh"};